var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"content"},[_c('Core')],1),_c('ProjectFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }